export const DOWNLOAD_FILTER_KEYS = [
  'timeperiod',
  'benchmark',
  'property_id',
  'brand',
  'city',
  'state'
];

export const REPORT_CONFIGS = {
  PROPERTY_PERFORMANCE_REPORT: {
    report_name: 'Property Performance Report',
    api_report_type: 'PROPERTY',
  },
  ALERT_REPORT: {
    report_name: 'Alert Report',
    api_report_type: 'ALERTS',
  }
};

export const DOWNLOAD_REPORT_BUTTON = 'Download Report';
export const PROPERTY_PERFORMANCE_REPORT = 'Property Performance Report';
export const ALERT_REPORT = 'Alert Report';
export const PDF_LABEL = 'PDF';
export const EXCEL_LABEL = 'Excel';
export const GENERATE_REPORT_TITLE = 'Generate Report?';
export const GENERATING_REPORT_PREFIX = 'Generating report for';
export const WITH_FILTERS_SUFFIX = 'with these filters:';
export const NO_FILTERS_APPLIED = 'No filters applied';
export const CANCEL = 'Cancel';
export const CONFIRM = 'Confirm';
export const EMAIL_LABEL = 'Email';
export const EMAIL_PLACEHOLDER = 'Enter your email address';
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const JOB_CREATED= 'Job Created';